export default __webpack_public_path__ + "static/media/5a.f6613298.png";